import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  setCookie(name: string, value: string, days: number) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }
  getCookie(name: string): string | null {
    return (
      document.cookie
        .split(';')
        .find((c) => c.trim().startsWith(`${name}=`))
        ?.split('=')[1] || null
    );
  }
  eraseCookie(name: string) {
    document.cookie = `${name}=; Max-Age=-99999999;`;
  }
}
